module.exports = __webpack_public_path__ + "static/media/43.71203c22.png";